import { useId, type ReactNode } from 'react';

/**
 * 폼 칸 한 벌 (2026-09-13 · H) — 라벨 · 입력 · 도움말.
 *
 * ★ 라벨이 입력과 도움말을 **함께 감싸면** 입력의 이름이 「성명 본인은 못 고치고 …」 처럼 도움말까지 붙어 읽힌다
 *   (화면 읽기 · 시험 모두). 그래서 라벨은 이름만 갖고(`htmlFor`), 도움말은 옆에 두고 `aria-describedby` 로 잇는다.
 */
export interface FieldA11y {
  id: string;
  'aria-describedby'?: string;
  'aria-required'?: true;
}

export function Field({
  label, required = false, hint, wide = false, children,
}: {
  label: string;
  required?: boolean;
  hint?: ReactNode;
  wide?: boolean;
  children: (a11y: FieldA11y) => ReactNode;
}) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  return (
    <div className={`hre-f${wide ? ' hre-f--wide' : ''}`}>
      <label className="hre-fl" htmlFor={id}>{label}{required && <i aria-hidden>*</i>}</label>
      {children({ id, ...(hintId ? { 'aria-describedby': hintId } : {}), ...(required ? { 'aria-required': true as const } : {}) })}
      {hint && <small id={hintId}>{hint}</small>}
    </div>
  );
}
